import AppContext from "PFApp/app_context";
import {
  activityTypeToSidePanelTypeMap,
  useDetailsPanelContext
} from "PFApp/booking/components/details_panel";
import { useQueryParams } from "PFCore/helpers/use_query_params";
import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { TEMPLATE_KEYS } from "../constants/templates";
import { CalendarMode, CalendarView } from "./types";

export const useQueryParamsTriggers = () => {
  const {
    store: {
      pages: {
        booking: { changeTab }
      }
    }
  } = useContext(AppContext);
  const { detailsData, openDetailsPanel } = useDetailsPanelContext();

  const history = useHistory();
  const queryParams = useQueryParams();
  const bookingId = queryParams.get("bookingId");
  const activityId = queryParams.get("activityId");
  const overbookings = queryParams.get("overbookings");
  const templateKey = queryParams.get("templateKey");
  const workforceMemberId = queryParams.get("workforceMemberId");
  const openAllocateManually = queryParams.get("openAllocateManually");

  useEffect(() => {
    history.replace({
      search: ""
    });
    if (bookingId && !isNaN(Number(bookingId))) {
      openDetailsPanel({
        id: Number(bookingId),
        type: "booking"
      });
    }
    if (activityId && templateKey && !isNaN(Number(activityId))) {
      const view = [TEMPLATE_KEYS.ENGAGEMENT, TEMPLATE_KEYS.AUDIT_ENGAGEMENT].includes(templateKey)
        ? CalendarView.EngagementsAndAuditEngagements
        : CalendarView.RolesAndAuditRoles;
      changeTab("overview", {
        calendarMode: CalendarMode.Projects,
        data: { filters: { fields: { id: activityId } }, view }
      });
      openDetailsPanel({
        id: Number(activityId),
        type: activityTypeToSidePanelTypeMap[templateKey],
        openAllocateManually: detailsData?.openAllocateManually || openAllocateManually === "true"
      });
    } else if (workforceMemberId) {
      changeTab("overview", {
        calendarMode: CalendarMode.Workforce,
        data: { filters: { fields: { workforce_member_id: workforceMemberId } } }
      });
      if (overbookings) {
        openDetailsPanel({
          id: Number(workforceMemberId),
          type: "overbookings"
        });
      }
    }
  }, [activityId, bookingId, openDetailsPanel]);
};
